export default __webpack_public_path__ + "static/SSSpyView_screenshot-2@mob2x-cac68882576ad0654a90aecc507132bb.jpg";